// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"0700b631","409":"454bb202","422":"0700b631"}[chunkId] + ".chunk.css";
};